import { createFileRoute } from "@tanstack/react-router";
import AdminSetDemoPage from "@/pages/admin/sets/detail/demo";
import { useSetsPermissions } from "@/pages/admin/sets";

export const Route = createFileRoute("/app/admin/sets/$setId/demo")({
  component: RouteComponent,
});

function RouteComponent() {
  const { setId } = Route.useParams();
  const {
    userCanViewAllSets,
    userCanEditAllSetDemos,
    userCanViewAllSetDemos,
  } = useSetsPermissions();

  return (
    <AdminSetDemoPage
      setId={Number(setId)}
      userCanViewAllSets={userCanViewAllSets}
      userCanEditAllSetDemos={userCanEditAllSetDemos}
      userCanViewAllSetDemos={userCanViewAllSetDemos}
    />
  );
}
